(function () {
  "use strict";

  var INIT_ATTR = "data-ecomato-faq-bound";

  function closeAllItems(items) {
    items.forEach(function (item) {
      item.setAttribute("data-open", "false");
      var trigger = item.querySelector(".ecomato-faq-trigger");
      if (trigger) trigger.setAttribute("aria-expanded", "false");
      var panel = item.querySelector(".ecomato-faq-panel");
      if (panel) panel.setAttribute("aria-hidden", "true");
    });
  }

  function openItem(item, trigger) {
    item.setAttribute("data-open", "true");
    trigger.setAttribute("aria-expanded", "true");
    var panel = item.querySelector(".ecomato-faq-panel");
    if (panel) panel.setAttribute("aria-hidden", "false");
  }

  function bindAccordion(accordion) {
    var items = accordion.querySelectorAll(".ecomato-faq-item");
    items.forEach(function (item) {
      var trigger = item.querySelector(".ecomato-faq-trigger");
      if (!trigger || trigger.getAttribute("data-ecomato-faq-trigger-bound") === "true") {
        return;
      }
      trigger.setAttribute("data-ecomato-faq-trigger-bound", "true");

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = item.getAttribute("data-open") !== "true";
        closeAllItems(items);
        if (willOpen) openItem(item, trigger);
      });
    });
  }

  function initEcomatoFaqSection(scope) {
    var root = scope && scope.querySelector ? scope : document;
    root.querySelectorAll('[data-ecomato-section="faq"]:not([' + INIT_ATTR + "])").forEach(function (sectionRoot) {
      sectionRoot.setAttribute(INIT_ATTR, "true");
      var accordion =
        sectionRoot.querySelector("[data-ecomato-faq-accordion]") ||
        sectionRoot.querySelector("[data-ecomato-faq]");
      if (!accordion || accordion.getAttribute("data-ecomato-faq-accordion-bound") === "true") {
        return;
      }
      accordion.setAttribute("data-ecomato-faq-accordion-bound", "true");
      bindAccordion(accordion);
    });
  }

  function boot(scope) {
    initEcomatoFaqSection(scope || document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) boot(event.target);
  });

  document.addEventListener("shopify:section:reorder", function () {
    boot(document);
  });
})();
